import React, { ReactNode, ElementType, ComponentPropsWithoutRef } from 'react';
import { classNames } from '@repo/ui/src/utils/classNames';

type Props<T extends ElementType> = {
  as?: T;
  children: ReactNode;
  className?: string;
  dataTestId?: string;
} & Omit<ComponentPropsWithoutRef<T>, 'as' | 'children' | 'className' | 'dataTestId'>;

const HeaderPaddingWrapper = <T extends ElementType = 'div'>({
  as,
  children,
  className = '',
  dataTestId,
  ...rest
}: Props<T>) => {
  const Component = as || 'div';

  return (
    <Component
      className={classNames('tw-px-4 sm:tw-px-10 lg:tw-px-20', className)}
      data-testid={dataTestId}
      {...(rest as any)}
    >
      {children}
    </Component>
  );
};

export default HeaderPaddingWrapper;
